// QRチケット(現状サンリオのみ. QR改札とは別)
export const checkIsQrPass = (masterPass) => {
  return masterPass.activation_method == "verification_string";
};
